"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SuperEventEmitter_1 = require("../Event/SuperEventEmitter");
/**
 * Widget state model.
 *
 * Stores state variables used for step and widget.
 *
 * @extendable
 */
class WidgetState extends SuperEventEmitter_1.SuperEventEmitter {
    /**
     * Constructs the state object.
     *
     * @param defaultState
     */
    constructor(defaultState = {}) {
        super();
        this.state = Object.assign({ stepIndex: 1 }, defaultState);
    }
    /**
     * Gets the current step index.
     *
     * @return {number}
     */
    getStepIndex() {
        return this.get("stepIndex");
    }
    /**
     * Sets the current step index.
     *
     * @param {number} step
     * @return {this}
     */
    setStepIndex(step) {
        this.set("stepIndex", step);
        return this;
    }
    /**
     * Gets the current step id.
     *
     * @return {string}
     */
    getStepId() {
        return this.get("stepId");
    }
    /**
     * Sets the current step id.
     *
     * @param {string} id
     * @return {this}
     */
    setStepId(id) {
        this.set("stepId", id);
        return this;
    }
    /**
     * Gets all values cloned.
     *
     * @return {*}
     */
    getAllCloned() {
        // Clone the state.
        return JSON.parse(JSON.stringify(this.state));
    }
    /**
     * Gets all values.
     *
     * @return {*}
     */
    getAll() {
        return this.state;
    }
    /**
     * Gets value at key.
     *
     * @param {string} key
     * @return {*}
     */
    get(key) {
        return this.state[key];
    }
    /**
     * Sets value at key.
     *
     * @param {string} key
     * @param value
     * @return {this}
     */
    set(key, value) {
        const prevValue = this.state[key];
        this.state[key] = value;
        this.emit("change", key, value, prevValue);
        this.emit(`change:${key}`, value, prevValue);
        return this;
    }
    /**
     * Triggers update on state.
     *
     * @return {this}
     */
    update() {
        this.emit("change", "", this.state);
        return this;
    }
    /**
     * Set extensions loaded
     *
     * @param {boolean} loaded
     * @return {boolean}
     */
    setExtensionsLoaded(loaded = true) {
        this.set("_extensionsLoaded", loaded);
    }
    /**
     * Determine with extensions loaded.
     *
     * @return {boolean}
     */
    areExtensionsLoaded() {
        return this.get("_extensionsLoaded");
    }
    /**
     * Set initializers ran.
     */
    setInitializersRan() {
        this.set("_initializersRan", true);
    }
    /**
     * Determine if initializers ran.
     *
     * @return {boolean}
     */
    didInitializersRan() {
        return this.get("_initializersRan");
    }
}
exports.WidgetState = WidgetState;
